import React, { memo } from 'react';
import { StructuredResponse as StructuredResponseType } from '../../Dto/chatbotStructuredResponse';
import StructuredTable from './StructuredTable';
import StructuredList from './StructuredList';
import StructuredGraph from './StructuredGraph';
import './StructuredComponents.css';

interface StructuredResponseProps {
  response: StructuredResponseType;
  isMobile?: boolean;
  isExpanded?: boolean;
}

const StructuredResponse: React.FC<StructuredResponseProps> = ({ 
  response, 
  isMobile = false, 
  isExpanded = false 
}) => {
  if (!response) {
    return null;
  }

  return (
    <div className={`chatbot-structured-response-container ${isMobile ? 'mobile' : ''}`}>
      {/* Tables */}
      {response.tables && (
        <div className="chatbot-tables-section">
          {/* Handle both single table object and array of tables */}
          {Array.isArray(response.tables) ? (
            response.tables.map((table, index) => (
              <StructuredTable
                key={index}
                table={table}
                isMobile={isMobile}
              />
            ))
          ) : (
            <StructuredTable
              table={response.tables}
              isMobile={isMobile}
            />
          )}
        </div>
      )}

      {/* List */}
      {response.list && (
        <div className="chatbot-list-section">
          <StructuredList
            list={response.list}
            isMobile={isMobile}
          />
        </div>
      )}

      {/* Graph - validate series data exists before rendering */}
      {response.graph && response.graph.data && response.graph.data.series && Array.isArray(response.graph.data.series) && response.graph.data.series.length > 0 && (
        <div className="chatbot-graph-section">
          <StructuredGraph
            graph={response.graph}
            isMobile={isMobile}
            isExpanded={isExpanded}
          />
        </div>
      )}
    </div>
  );
};

export default memo(StructuredResponse);
